module.exports = __webpack_public_path__ + "static/img/chat-logo.d223ea48.png";